export enum RateAdjustmentOptions {
    none = 'none',
    discount = 'discount',
    markup = 'markup',
}
